var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgEmailEdit = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m18.644 25.811 52.133-7.166c3.584-.492 6.929 1.973 7.433 5.478l5.495 38.243c.503 3.505-2.017 6.777-5.601 7.27L25.97 76.801c-3.584.492-6.929-1.973-7.433-5.479l-5.495-38.242c-.503-3.506 2.017-6.777 5.601-7.27Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m81.769 49.016-4.21-24.95c-.504-3.506-3.196-5.651-6.78-5.159l-52.133 7.167c-3.584.492-6.105 3.763-5.6 7.27l5.494 38.242c.504 3.505 3.849 5.97 7.433 5.478l27.221-4.014"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M77.558 24.787 48.834 51.172l-35.79-17.829"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m23.926 72.647 2.914-4.15m2.014-2.87 9.158-13.043"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M71.186 78.744A13.697 13.697 0 0 0 84.938 64.7c-.162-7.758-6.582-14.046-14.34-14.046A13.697 13.697 0 0 0 56.848 64.7c.162 7.757 6.581 14.045 14.339 14.045Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m75.767 62.785.696-.68a1.787 1.787 0 0 0 0-2.564 1.862 1.862 0 0 0-1.31-.53c-.497 0-.962.189-1.311.53l-.696.68 2.621 2.564Zm-3.225-1.972-5.152 5.039a.975.975 0 0 0-.242.383l-.955 2.823a.411.411 0 0 0 .104.427.432.432 0 0 0 .437.1l2.884-.933c.148-.048.284-.13.393-.237l5.151-5.039-2.62-2.563Z"
  }));
};
export default SvgEmailEdit;